export default function unique(arr) {
    return arr.filter((d, i, s) => {
        return s.indexOf(d) === i;
    });
}
